<template>
    <div class="wrap-personnel">
        <div class="dialog_addperson" v-if="isShow">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" :title="title"
                :fullscreen="true" :visible.sync="isShow" center :before-close="fnClosePersonnel">
                <div class="left-item item">
                    <div class="row">
                        <div class="row-item">
                            参数说明
                            <span style="color:#F56C6C;">（* 必填）</span>
                        </div>
                        <div class="row-item">参数值</div>
                    </div>
                    <div class="row">
                        <div class="row-item" style="color:#F56C6C;">*身份证号</div>
                        <div class="row-item">
                            <el-input :disabled="path == 'personnelAudit'" placeholder="正确输入身份证号将自动搜索人员数据库"
                                v-model="formData.idcard" @input="fnSearchPersonnelDatabase(formData.idcard)">
                            </el-input>
                            <div slot="reference" style="color:#E6A23C;margin-left: 10px;cursor:pointer;">
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*姓名</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.name"
                                :filter-method="searchPersonnelDatabaseNameFilter" style="border-radius: 0;"
                                :disabled="path == 'personnelAudit'" clearable filterable placeholder="请输入全名,不支持模糊搜索"
                                ref="searchPersonnelRef" :no-data-text="notPersonnelText" @change="fnChangePersonnel">
                                <el-option v-for="item in searchPersonnelDatabaseName" :label="item.idcard"
                                    :value="item" style="height: 65px;">
                                    <img :src="item.photo"
                                        style="float: left;width: 60px;height: 60px;border-radius: 50%;margin:2px 15px 2px 0;" />
                                    <span style="float: left;line-height: 60px;color: #8492a6;">{{ item.idcard }}</span>
                                </el-option>
                            </el-select>
                            <el-button :disabled="path == 'personnelAudit'" size="mini" type="primary"
                                @click="fnSearchPersonnelDatabaseName" style="margin-left: 10px;">搜索人员库</el-button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">性别</div>
                        <div class="row-item">
                            <el-radio-group :disabled="path == 'personnelAudit'" v-model="formData.sex">
                                <el-radio :label="1">男</el-radio>
                                <el-radio :label="2">女</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*班组</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.department" filterable placeholder="请选择"
                                style="border-radius: 0;" @change="fnChangeDepartment">
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in teamList" :key="item.id" :label="item.name"
                                    :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*工人工种类型</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.position" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in workList" :key="item.id" :label="item.name"
                                    :value="item.value"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">卡号</div>
                        <div class="row-item">
                            <el-input v-model="formData.card_no"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*手机号</div>
                        <div class="row-item">
                            <el-input :disabled="path == 'personnelAudit'" v-model="formData.phone"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*证件有效期</div>
                        <div class="row-item">
                            <div v-if="showDate">
                                <el-date-picker :disabled="path == 'personnelAudit'" v-model="formData.validity_period"
                                    value-format="yyyy-MM-dd" type="daterange" start-placeholder="开始日期"
                                    end-placeholder="结束日期" unlink-panels placeholder="选择日期"></el-date-picker>
                                <el-button :disabled="path == 'personnelAudit'" size="mini" type="primary"
                                    @click="showDate = !showDate">是否长期</el-button>
                            </div>
                            <div v-else>
                                <el-date-picker :disabled="path == 'personnelAudit'" v-model="dateStart"
                                    value-format="yyyy-MM-dd" type="date" placeholder="选择日期"></el-date-picker>
                                <el-input v-model="dateEnd" :disabled="true"></el-input>
                                <el-button :disabled="path == 'personnelAudit'" size="mini" type="primary"
                                    @click="showDate = !showDate">是否长期</el-button>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*出生日期</div>
                        <div class="row-item">
                            <el-date-picker :disabled="path == 'personnelAudit'" v-model="formData.birthday"
                                value-format="yyyy-MM-dd" type="date" placeholder="选择日期时间"></el-date-picker>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*民族</div>
                        <div class="row-item">
                            <el-input :disabled="path == 'personnelAudit'" v-model="formData.nation"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*贵州人社厅 - 岗位类型</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.postType" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option label="施工员" value="施工员"></el-option>
                                <el-option label="质量员" value="质量员"></el-option>
                                <el-option label="安全员" value="安全员"></el-option>
                                <el-option label="标准员" value="标准员"></el-option>
                                <el-option label="材料员" value="材料员"></el-option>
                                <el-option label="机械员" value="机械员"></el-option>
                                <el-option label="劳务员" value="劳务员"></el-option>
                                <el-option label="资料员" value="资料员"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*贵州省建委 - 岗位类型</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.positionTypeStr" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option value="1001" label="总监理工程师"></el-option>
                                <el-option value="1002" label="副总监理工程师"></el-option>
                                <el-option value="1003" label="安全监理工程师"></el-option>
                                <el-option value="1004" label="专业监理工程师"></el-option>
                                <el-option value="1005" label="监理工程师"></el-option>
                                <el-option value="1006" label="监理员"></el-option>
                                <el-option value="1007" label="监理安全员"></el-option>
                                <el-option value="1008" label="项目总工程师"></el-option>
                                <el-option value="1009" label="项目经理"></el-option>
                                <el-option value="1010" label="工程经理"></el-option>
                                <el-option value="1011" label="项目技术负责人"></el-option>
                                <el-option value="1012" label="项目工程师"></el-option>
                                <el-option value="1013" label="项目管理员"></el-option>
                                <el-option value="1014" label="项目副经理"></el-option>
                                <el-option value="1015" label="项目总监"></el-option>
                                <el-option value="1016" label="施工员"></el-option>
                                <el-option value="1017" label="质量员"></el-option>
                                <el-option value="1018" label="安全员"></el-option>
                                <el-option value="1019" label="标准员"></el-option>
                                <el-option value="1020" label="材料员"></el-option>
                                <el-option value="1021" label="机械员"></el-option>
                                <el-option value="1022" label="劳务员"></el-option>
                                <el-option value="1023" label="资料员"></el-option>
                                <el-option value="1024" label="总监理工程师代表"></el-option>
                                <el-option value="1025" label="测量员"></el-option>
                                <el-option value="1026" label="试验员"></el-option>
                                <el-option value="1027" label="造价员"></el-option>
                                <el-option value="1028" label="质量负责人"></el-option>
                                <el-option value="1029" label="安全负责人"></el-option>
                                <el-option value="1030" label="技术负责人"></el-option>
                                <el-option value="1031" label="生产经理"></el-option>
                                <el-option value="1032" label="物资材料工程师"></el-option>
                                <el-option value="1099" label="其它"></el-option>
                            </el-select>


                            <el-popover placement="top-start" title="工人所属公司参建类型不同，则管理岗位不同" width="600" trigger="hover">

                                <p>1，不是管理人员请选择：其它</p>
                                <p>2，监理单位。包含参建类型：监理，可选择的管理岗位为： 总监理工程师、副总监理工程师、总监理工程师代表、专业监理工程师、
                                    监理工程师、监理员、安全监理工程师、监理安全员、其它</p>
                                <p>3，建设单位。包含参建类型：建设单位，可选择的管理岗位为： 项目总工程师、项目经理、工程经理、项目技术负责人、项目工程师</p>
                                <p>4，施工单位（总承包）。包含参建类型：总承包单位，可选择的管理岗位为： 项目经理、项目副经理、项目总监、项目工程师、项目管理员、施工员、
                                    质量员、安全员、标准员、材料员、机械员、劳务员、资料员、测量员、 试验员、造价员、质量负责人、安全负责人、技术负责人</p>
                                <p>5，其它参建单位（除了上述三种参建类型之外的所有类型）。 可选择的管理岗位为： 项目经理、劳务员、安全员、生产经理、技术负责人、物资材料工程师、 其它</p>

                                <div slot="reference" style="color:#F56C6C;margin-left: 10px;cursor:pointer;">注意事项查看
                                </div>
                            </el-popover>

                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*是否在职</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.whetherOnJob">
                                <el-radio :label="1">在职</el-radio>
                                <el-radio :label="0">离职</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*是否在岗</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.whetherOnDuty">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">是否短期工</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.whetherTempWorker">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*人员类型</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.personnel_type" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option label="企业人员" value="1"></el-option>
                                <el-option label="项目人员" value="2"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*工种工资核定方式</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.wageApprovedWay" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option label="天" value="天"></el-option>
                                <el-option label="小时" value="小时"></el-option>
                                <el-option label="月" value="月"></el-option>
                                <el-option label="件" value="件"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*工种工资核定标准（元）</div>
                        <div class="row-item">
                            <el-input v-model="formData.wageCriterion"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*工资支付日期</div>
                        <div class="row-item">
                            <el-input v-model="formData.payDate" type="number" placeholder="1~31日之间"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*是否有劳动合同</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.hasContract">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*是否购买工伤保险</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.hasWorkInsurance">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*工人工资卡银行卡号</div>
                        <div class="row-item">
                            <el-input v-model="formData.payRollBankCardNum"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*工资卡类别</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.payRollBankCardType">
                                <el-radio label="社会保障卡">社会保障卡</el-radio>
                                <el-radio label="银行卡">银行卡</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*工人工资卡所属银行支行名称</div>
                        <div class="row-item">
                            <el-input v-model="formData.payRollBankName"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*工人工资卡所属银行</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.payrollBank" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in GZS.bankName" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">
                            银行联号
                            <a style="display: block;margin-left: 5px;font-size: 12px;color: #3a8ee6;"
                                href="http://www.lianhanghao.com" target="_blank">点击查询</a>
                        </div>
                        <div class="row-item">
                            <el-input v-model="formData.bankLink" :disabled="isUploadContract"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*是否购买意外伤害保险</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.hasAccidentInsurance">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*是否参加城乡居民医疗保险</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.miurInsurance">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*是否参加城乡居民养老保险</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.endowmentInsurance">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*工人合同编号</div>
                        <div class="row-item">
                            <el-input v-model="formData.contractCode" :disabled="isUploadContract"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*人员角色</div>
                        <div class="row-item">
                            <el-select size="small" :disabled="isUploadContract" v-model="formData.role" filterable
                                placeholder="请选择" style="border-radius: 0;">
                                <el-option label="管理人员" value="管理人员"></el-option>
                                <el-option label="务工人员" value="务工人员"></el-option>
                                <el-option label="劳资专管员" value="劳资专管员"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*合同期限类型</div>
                        <div class="row-item">
                            <el-select size="small" :disabled="isUploadContract" v-model="formData.laborContractType"
                                filterable placeholder="请选择" style="border-radius: 0;">
                                <el-option label="固定期限合同" value="固定期限合同"></el-option>
                                <el-option label="以完成一定工作为期限的合同" value="以完成一定工作为期限的合同"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*合同起始日期</div>
                        <div class="row-item">
                            <el-date-picker :disabled="isUploadContract" v-model="formData.contractStartDate"
                                value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*合同签订日期</div>
                        <div class="row-item">
                            <el-date-picker :disabled="isUploadContract" v-model="formData.contractValidDate"
                                value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*合同终止日期</div>
                        <div class="row-item">
                            <el-date-picker :disabled="isUploadContract" v-model="formData.contractInvalidDate"
                                value-format="yyyy-MM-dd HH:mm:ss" type="datetime" placeholder="选择日期时间">
                            </el-date-picker>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*签订书面合同类型</div>
                        <div class="row-item">
                            <el-select size="small" :disabled="isUploadContract" v-model="formData.contractType"
                                filterable placeholder="请选择" style="border-radius: 0;">
                                <el-option label="纸质合同" value="纸质合同"></el-option>
                                <el-option label="电子合同" value="电子合同"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">是否上传</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.is_need_upload">
                                <el-radio :label="1">上传</el-radio>
                                <el-radio :label="0">不传</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                </div>

                <div class="right-item item">
                    <div class="row">
                        <div class="row-item">
                            参数说明
                            <span style="color:#F56C6C;">（* 必填）</span>
                        </div>
                        <div class="row-item">参数值</div>
                    </div>
                    <div class="row">
                        <div class="row-item">*发证机关</div>
                        <div class="row-item">
                            <el-input :disabled="path == 'personnelAudit'" v-model="formData.cert_org"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*住址</div>
                        <div class="row-item">
                            <el-input :disabled="path == 'personnelAudit'" v-model="formData.address"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*身份证头像</div>
                        <div class="row-item">
                            <el-upload :disabled="path == 'personnelAudit'" class="avatar-uploader" action=""
                                list-type="picture-card"
                                :http-request=" res => { beforeCardPicUpload(res.file, 'id_card_pic');}"
                                :show-file-list="false">
                                <img v-if="formData.id_card_pic" :src="formData.id_card_pic" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">身份证照片正面</div>
                        <div class="row-item">
                            <el-upload :disabled="path == 'personnelAudit'" class="avatar-uploader" action=""
                                list-type="picture-card"
                                :http-request=" res => { beforeCardPicUpload(res.file, 'id_card_pic_positive');}"
                                :show-file-list="false">
                                <img v-if="formData.id_card_pic_positive" :src="formData.id_card_pic_positive"
                                    class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <el-button :disabled="path == 'personnelAudit'" type="primary"
                                @click="fnOpenCameraPage('id_card_pic_positive')">摄像头抓拍</el-button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">身份证照片反面</div>
                        <div class="row-item">
                            <el-upload :disabled="path == 'personnelAudit'" class="avatar-uploader" action=""
                                list-type="picture-card"
                                :http-request=" res => { beforeCardPicUpload(res.file, 'id_card_pic_negative');}"
                                :show-file-list="false">
                                <img v-if="formData.id_card_pic_negative" :src="formData.id_card_pic_negative"
                                    class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <el-button :disabled="path == 'personnelAudit'" type="primary"
                                @click="fnOpenCameraPage('id_card_pic_negative')">摄像头抓拍</el-button>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">现场人员可见光照</div>
                        <div class="row-item">
                            <el-upload :disabled="path == 'personnelAudit'" class="avatar-uploader" action=""
                                list-type="picture-card"
                                :http-request=" res => { beforeCardPicUpload(res.file, 'photo');}"
                                :show-file-list="false">
                                <img v-if="formData.photo" :src="formData.photo" class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                            <el-button :disabled="path == 'personnelAudit'" type="primary"
                                @click="fnOpenCameraPage('photo')">摄像头抓拍</el-button>
                            <span style="width: 40%; display: inline-block; vertical-align: middle"
                                :style="{ color: faceVerifRes.indexOf('成功') != -1 ? '' : 'red' }">{{ faceVerifRes }}</span>
                        </div>
                    </div>

                    <div class="row">
                        <div class="row-item">合同附件名称</div>
                        <div class="row-item">
                            <el-input v-model="formData.appendixName"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*合同附件</div>
                        <div class="row-item">

                            <el-upload action="" list-type="picture-card" class="avatar-uploader-s"
                                :file-list="contractAppendixList" :on-preview="handlePictureCardPreview"
                                :on-remove="handleRemove"
                                :http-request=" res => { beforeCardPicUpload(res.file, 'contractAppendix');}">
                                <i class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>

                            <el-dialog :visible.sync="dialogVisible" :modal="false">
                                <img width="100%" :src="dialogImageUrl" alt="">
                            </el-dialog>

                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">进场确认附件</div>
                        <div class="row-item">
                            <el-upload :disabled="path == 'personnelAudit'" class="avatar-uploader" action=""
                                list-type="picture-card"
                                :http-request=" res => { beforeCardPicUpload(res.file, 'approachAffirmUrl');}"
                                :show-file-list="false">
                                <img v-if="formData.approachAffirmUrl" :src="formData.approachAffirmUrl"
                                    class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">退场确认附件</div>
                        <div class="row-item">
                            <el-upload :disabled="path == 'personnelAudit'" class="avatar-uploader" action=""
                                list-type="picture-card"
                                :http-request=" res => { beforeCardPicUpload(res.file, 'departureAffirmUrl');}"
                                :show-file-list="false">
                                <img v-if="formData.departureAffirmUrl" :src="formData.departureAffirmUrl"
                                    class="avatar" />
                                <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                            </el-upload>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">紧急联系人姓名</div>
                        <div class="row-item">
                            <el-input v-model="formData.emergencyContactName"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">紧急联系人电话</div>
                        <div class="row-item">
                            <el-input v-model="formData.emergencyContactPhone"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">学历</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.academicdegree" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in GZS.academicdegree" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">学位</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.degree" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in GZS.degree" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*文化程度</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.education" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in GZS.education" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">籍贯</div>
                        <div class="row-item">
                            <el-input v-model="formData.nativePlac"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">特长</div>
                        <div class="row-item">
                            <el-input v-model="formData.speciality"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">是否加入工会</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.unionMembership">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">是否有重大病史</div>
                        <div class="row-item">
                            <el-radio-group v-model="formData.isMedicalHistory">
                                <el-radio label="是">是</el-radio>
                                <el-radio label="否">否</el-radio>
                            </el-radio-group>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">计量单位</div>
                        <div class="row-item">
                            <el-select :disabled="isUploadContract" size="small" v-model="formData.unit" filterable
                                placeholder="请选择" style="border-radius: 0;">
                                <el-option label="米" value="米"></el-option>
                                <el-option label="平方米" value="平方米"></el-option>
                                <el-option label="立方米" value="立方米"></el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">计量单价</div>
                        <div class="row-item">
                            <el-input v-model="formData.unitPrice"></el-input>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">*政治面貌</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.politicalFace" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in GZS.politicalFace" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                    <div class="row">
                        <div class="row-item">婚姻状况</div>
                        <div class="row-item">
                            <el-select size="small" v-model="formData.maritalStatus" filterable placeholder="请选择"
                                style="border-radius: 0;">
                                <el-option label="请选择" value=""></el-option>
                                <el-option v-for="item in GZS.maritalStatus" :key="item" :label="item" :value="item">
                                </el-option>
                            </el-select>
                        </div>
                    </div>
                </div>
                <div style="'width:100%;height:50px;"></div>
                <div slot="footer" v-if="path == 'personnelAudit'" class="dialog-footer printhide">
                    <div class="btn_line">
                        <div class="search-btn red" @click="fnClosePersonnel"><span>取消</span></div>
                        <!-- <div class="search-btn" @click="fnAddPersonnel"><span>审核通过</span></div> -->
                        <div class="search-btn" @click="fnGetPerisBlack"><span>审核通过</span></div>
                        <div class="search-btn orange" @click="fnAuditNot"><span>审核不通过</span></div>
                    </div>
                </div>
                <div slot="footer" v-else class="dialog-footer printhide">
                    <div class="btn_line">
                        <div class="search-btn red" @click="fnClosePersonnel"><span>取消</span></div>
                        <div class="search-btn orange" @click="fnReadCard"><span>读取身份证信息</span></div>
                        <!-- <div class="search-btn" @click="fnAddPersonnel"><span>保存</span></div> -->
                        <div class="search-btn" @click="fnGetPerisBlack"><span>保存</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>

        <!-- 摄像头抓拍弹窗 -->
        <div class="dialog_camera" v-if="cameraIsShow">
            <el-dialog class="camera-photo" title="摄像头抓拍" :visible.sync="cameraIsShow" center :modal="false"
                @close="fnCloseCamera">
                <div class="photo-box">
                    <video id="cameraVideo" width="400px" height="300px"></video>
                    <canvas id="cameraCanvas" width="400px" height="300px"></canvas>
                    <div class="identify-result">{{ faceVerifRes }}</div>
                </div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn" @click="fnSnap"><span>拍照</span></div>
                        <div class="search-btn red" @click="fnCloseCameraWin"><span>取消</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>

        <!-- 人员下发失败信息弹窗 -->
        <div class="dialog_isBlack" v-if="isBlackShow">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="提示信息"
                :visible.sync="isBlackShow" center>
                <div>该人员在人员黑名单，原因：{{ blackMsg }}，是否继续保存?</div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn red" @click="fnClosePersonnel"><span>否</span></div>
                        <div class="search-btn" @click="fnAddPersonnel"><span>是</span></div>
                    </div>
                </div>
            </el-dialog>
        </div>
        <!-- 是否修改班组 -->
        <div class="dialog_isBlack" v-if="isChangeDepartmentShow">
            <el-dialog :custom-class="'animate__animated animate__fadeIn'" :modal="false" title="提示信息"
                :visible.sync="isChangeDepartmentShow" center>
                <div>请离场该人员并上传至建委或人社平台后才能修改班组!</div>
                <div slot="footer" class="dialog-footer">
                    <div class="btn_line">
                        <div class="search-btn" style="width: 80px;" @click="isChangeDepartmentShow = false">
                            <span>关闭</span>
                        </div>
                    </div>
                </div>
            </el-dialog>
        </div>
    </div>
</template>

<script>
    import sha1 from 'js-sha1';
    import APP from '@/utils/base';
    import GZS from '@/configure/gzs';
    import request from '@/utils/request';
    import {
        fnUpload
    } from '@/utils/upload';
    import {
        Loading
    } from 'element-ui';
    import {
        fnCookie
    } from '@/utils/localStorage';
    import * as imageConversion from 'image-conversion';

    export default {
        // setData 和 path 为 人员审核页面传参 path = 'personnelAudit'
        props: ['editInfo', 'setData', 'path'],
        data() {
            return {
                searchPersonnelDatabaseName: [], // 搜索人员库
                notPersonnelText: '请点击右侧按钮搜索',
                AuditData: {
                    // 人员审核编辑信息
                    personnel_id: null,
                    explain: '',
                    status: ''
                },
                isBlackShow: false,
                isShow: false,
                dialogImageUrl: '',
                dialogVisible: false,
                GZS: GZS,
                show: true,
                message: '',
                isUploadContract: false, // 是否上传
                addEditpersonnelInfo: {},
                personnelExtend: {}, // 人员扩展信息
                mediaStreamTrack: null, // 摄像头
                cameraIsShow: false, // 摄像头弹窗
                title: '编辑人员',
                teamList: [], // 班组列表
                workList: [], // 工种列表
                contractAppendixList: [], // 合同图片列表
                faceVerifRes: '', // 人脸验证结果
                personnel_Id: '', // 人员扩展信息id
                showDate: true,
                dateStart: '', // 是否长期的第一个输入框
                dateEnd: '长期',
                jibenData: {
                    id: '', // 人员id
                    name: '', // 姓名
                    sex: 1, // 性别
                    address: '', // 住址
                    card_no: '', // 卡号
                    department: '', // 部门 班组
                    position: '', // 工种 职位
                    phone: '', //手机号
                    idcard: '', // 身份证号
                    idcard_sha1: '', // 身份证sha加密
                    cert_org: '', // 发证机关
                    validity_period: '', // 证件有效期
                    birthday: '', // 生日
                    nation: '', // 民族
                    id_card_pic: '', // 身份证头像
                    id_card_pic_positive: '', // 身份证正面照
                    id_card_pic_negative: '', // 身份证反面照,
                    photo: '' // 现场人员可见光照片
                },
                formData: {
                    id: null, // 人员id
                    project_id: null, // 项目id
                    name: null, // 姓名
                    sex: 1, // 性别
                    address: null, // 住址
                    card_no: null, // 卡号
                    department: null, // 部门 班组
                    position: null, // 工种 职位
                    phone: null, // 手机号
                    idcard: null, // 身份证号
                    idcard_sha1: null, // 身份证sha加密
                    cert_org: null, // 发证机关
                    validity_period: null, // 证件有效期
                    birthday: null, // 生日
                    nation: null, // 民族
                    id_card_pic: null, // 身份证头像
                    id_card_pic_positive: null, // 身份证正面照
                    id_card_pic_negative: null, // 身份证反面照,
                    photo: null, // 现场人员可见光照片
                    is_need_upload: 1, // 是否需要上传
                    postType: '劳务员', // 岗位类型
                    positionTypeStr: '', // 贵州省岗位类型
                    payRollBankCardNum: null, // 工人工资卡银行卡号
                    payRollBankCardType: '银行卡', // 工资卡类别
                    payRollBankName: null, // 工人工资卡所属银行支行名称
                    payrollBank: null, // 工人工资卡所属银行
                    hasContract: '是', // 是否有劳动合同
                    hasWorkInsurance: '是', // 是否购买工伤保险
                    whetherOnDuty: '是', // 是否在岗
                    whetherTempWorker: '否', // 是否短期工
                    hasAccidentInsurance: '是', // 是否购买意外伤害保险
                    miurInsurance: '是', // 是否参加城乡居民医疗保险
                    endowmentInsurance: '是', // 是否参加城乡居民养老保险
                    wageApprovedWay: null, // 工种工资核定方式
                    wageCriterion: null, // 工种工资核定标准（元）
                    payDate: null, // 工资支付日期
                    whetherOnJob: 1, // 是否在职
                    personnel_type: '2', // 人员类型: 1: 企业人员; 2: 项目人员
                    contractCode: null, // 合同编号
                    role: '务工人员', // 人员角色
                    laborContractType: '以完成一定工作为期限的合同', // 合同期限类型
                    contractStartDate: null, // 合同起始日期
                    contractValidDate: null, // 合同签订日期
                    contractInvalidDate: null, // 合同终止日期
                    contractType: '纸质合同', // 签订书面合同类型
                    contractAppendix: null, // 合同附件
                    academicdegree: '高中', // 学历
                    degree: '无学位', // 学位
                    education: '普通高中', // 文化程度
                    nativePlac: null, // 籍贯
                    speciality: null, // 特长
                    unionMembership: '是', // 是否加入工会
                    isMedicalHistory: '否', // 是否有重大病史
                    maritalStatus: '已婚', // 婚姻状况
                    politicalFace: '群众', // 政治面貌
                    emergencyContactName: null, // 紧急联系人姓名
                    emergencyContactPhone: null, // 紧急联系人电话
                    unit: null, // 计量单位
                    unitPrice: null, // 计量单价
                    appendixName: null, // 合同附件名称
                    approachAffirmUrl: null, // 进场确认附件
                    departureAffirmUrl: null, // 退场确认附件
                    bankLink: null // 银行联号
                },
                kuozandata: {
                    postType: '', // 岗位类型
                    positionTypeStr: '', // 贵州省岗位类型
                    payRollBankCardNum: '', // 工人工资卡银行卡号
                    payRollBankCardType: '', // 工资卡类别
                    payRollBankName: '', // 工人工资卡所属银行支行名称
                    payrollBank: '', // 工人工资卡所属银行
                    hasContract: '是', // 是否有劳动合同
                    hasWorkInsurance: '是', // 是否购买工伤保险
                    whetherOnDuty: '是', // 是否在岗
                    whetherTempWorker: '否', // 是否短期工
                    hasAccidentInsurance: '是', // 是否购买意外伤害保险
                    miurInsurance: '是', // 是否参加城乡居民医疗保险
                    endowmentInsurance: '是', // 是否参加城乡居民养老保险
                    wageApprovedWay: '', // 工种工资核定方式
                    wageCriterion: '', // 工种工资核定标准（元）
                    payDate: '', // 工资支付日期
                    whetherOnJob: 1, // 是否在职
                    personnel_type: 2, // 人员类型: 1: 企业人员; 2: 项目人员
                    contractCode: '', // 合同编号
                    role: '', // 人员角色
                    laborContractType: '', // 合同期限类型
                    contractStartDate: '', // 合同起始日期
                    contractValidDate: '', // 合同签订日期
                    contractInvalidDate: '', // 合同终止日期
                    contractType: '', // 签订书面合同类型
                    contractAppendix: '', // 合同附件
                    approachAffirmUrl: null, // 进场确认附件
                    departureAffirmUrl: null, // 退场确认附件
                    academicdegree: '高中', // 学历
                    degree: '无学位', // 学位
                    education: '普通高中', // 文化程度
                    nativePlac: '', // 籍贯
                    speciality: '', // 特长
                    unionMembership: '是', // 是否加入工会
                    isMedicalHistory: '否', // 是否有重大病史
                    maritalStatus: '已婚', // 婚姻状况
                    politicalFace: '群众', // 政治面貌
                    emergencyContactName: '', // 紧急联系人姓名
                    emergencyContactPhone: '', // 紧急联系人电话
                    unit: '', // 计量单位
                    unitPrice: '', // 计量单价
                    appendixName: '', // 合同附件名称
                    bankLink: null // 银行联号
                },
                blackMsg: '',
                changeDepartment: {
                    department: null,
                    extend: null,
                    status: null
                },
                isChangeDepartmentShow: false
            };
        },
        watch: {
            formData: {
                handler: function(_newVal) {
                    if (this.editInfo && this.editInfo.id) {} else {
                        fnCookie('lastPersonnelInfo', _newVal);
                    }
                },
                deep: true
            }
        },
        created() {
            let _that = this;
            _that.fnGetWork();
            _that.fnGetTeam();
            _that.fnInit();
            // 人员审核页面参数
            if (this.setData) {
                this.AuditData.personnel_id = this.setData.personnel_id;
                this.AuditData.explain = this.setData.explain;
                this.AuditData.status = this.setData.status;
            }
            setTimeout(() => {
                _that.isShow = true;
                document.getElementsByClassName('menu_bar')[0].style.display = 'none';
                document.getElementsByClassName('copy_box')[0].style.display = 'none';
            }, 300);
        },
        beforeDestroy() {
            this.fnCloseCamera();
        },
        destroyed() {
            document.getElementsByClassName('menu_bar')[0].style.display = '';
            document.getElementsByClassName('copy_box')[0].style.display = '';
        },
        methods: {
            // 初始化
            fnInit() {
                if (this.path == 'personnelAudit') {
                    this.title = '审核人员';
                }
                // 编辑时需要对传过来的数据进行处理
                if (this.editInfo && this.editInfo.id) {
                    for (let _key in this.editInfo) {
                        if (_key != 'project_name') {
                            if (_key == 'validity_period') {
                                if (this.editInfo[_key]) {
                                    let _validity_period = this.editInfo[_key].split('-');
                                    if (_validity_period[1] == '长期') {
                                        this.showDate = false;
                                        this.dateStart = APP.fnDateAddEm_public(_validity_period[0]);
                                        this.dateEnd = _validity_period[1];
                                    } else {
                                        this.showDate = true;
                                        this.formData[_key] = [APP.fnDateAddEm_public(_validity_period[0]), APP
                                            .fnDateAddEm_public(_validity_period[1])
                                        ];
                                    }
                                }
                            } else {
                                if (_key == 'status') {
                                    this.changeDepartment.status = this.editInfo[_key];
                                }
                                if (_key == 'department') {
                                    this.changeDepartment.department = this.editInfo[_key];
                                }
                                if (_key == 'extend') {
                                    this.changeDepartment.extend = this.editInfo[_key];
                                }
                                // if (_key == 'extend' && this.editInfo[_key] && (this.editInfo[_key].indexOf('gzzj') !== -1 || this.editInfo[_key].indexOf('gzs') !== -1)) {
                                //   // 已上传时禁用输入框
                                //   this.isReadOnly = true;
                                // }
                                if (this.formData.hasOwnProperty(_key)) {
                                    this.formData[_key] = this.editInfo[_key];
                                }
                            }
                        }
                    }
                    this.fnGetExtend();
                } else {
                    this.title = '添加人员';
                    if (this.editInfo) {
                        for (let _key in this.editInfo) {
                            this.formData[_key] = this.editInfo[_key];
                            if (_key == 'photo' && this.editInfo[_key]) {
                                let _photo = APP.fnBase64ToFile(this.editInfo[_key]);
                                this.beforeCardPicUpload(_photo, 'photo');
                            }
                        }
                    } else {
                        let _lastPersonnelInfo = fnCookie('lastPersonnelInfo');
                        if (_lastPersonnelInfo) {
                            for (let _key in _lastPersonnelInfo) {
                                this.formData[_key] = _lastPersonnelInfo[_key];
                            }
                        }
                        this.formData.id = '';
                    }
                }
            },
            // 修改班组
            fnChangeDepartment(e) {
                if (this.editInfo && this.editInfo.id) {
                    let _status = this.changeDepartment.status;
                    let _department = this.changeDepartment.department;
                    let _extend = this.changeDepartment.extend ? JSON.parse(this.changeDepartment.extend) : null;
                    let _statusUpdateAt = _extend && _extend.statusUpdateAt ? new Date(_extend.statusUpdateAt)
                        .getTime() : null; // 状态更新时间
                    let _gzs = _extend && _extend.gzs ? new Date(_extend.gzs).getTime() : null; // 上传贵州人社
                    let _gzzj = _extend && _extend.gzzj ? new Date(_extend.gzzj).getTime() : null; // 上传贵州省
                    if (_gzzj || _gzs) {
                        if (_status == 1) {
                            this.formData.department = _department;
                            this.isChangeDepartmentShow = true;
                        } else {
                            if (!_statusUpdateAt) {
                                this.formData.department = _department;
                                this.isChangeDepartmentShow = true;
                            } else {
                                if ((_gzzj && _statusUpdateAt > _gzzj) || (_gzs && _statusUpdateAt > _gzs)) {
                                    this.formData.department = _department;
                                    this.isChangeDepartmentShow = true;
                                }
                            }
                        }
                    }
                }
            },
            // 获取班组信息
            fnGetTeam() {
                request({
                        url: 'team/getTeam',
                        method: 'GET'
                    })
                    .then(res => {
                        let _teamList = [];
                        res.data.forEach(_item => {
                            _teamList.push({
                                name: _item.name,
                                id: _item.id,
                                value: _item.id + '#' + _item.name
                            });
                        });
                        this.teamList = _teamList;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 获取工种信息
            fnGetWork() {
                request({
                        url: 'personnel/getWork',
                        method: 'GET',
                        params: {
                            region_id: 12 // 贵州区域id为12
                        }
                    })
                    .then(res => {
                        let _workList = [];
                        res.data.forEach(_item => {
                            _workList.push({
                                name: _item.name,
                                id: _item.id,
                                value: _item.id + '#' + _item.name
                            });
                        });
                        this.workList = _workList;
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 获取扩展信息
            fnGetExtend() {
                request({
                        url: 'personnel/getPersonnelExtend',
                        method: 'GET',
                        params: {
                            region: 'gzs',
                            personnel_id: this.editInfo.id
                        }
                    })
                    .then(res => {
                        let resdata = res.data[0];
                        for (let _key in this.formData) {
                            if (resdata[_key] != undefined) {
                                this.formData[_key] = resdata[_key];
                            }
                        }
                        if (this.formData.personnel_type == 1) {
                            // 企业人员
                            this.formData.whetherOnJob = this.formData.whetherOnJob == '在职' ? 1 : 0;
                        } else {
                            this.formData.whetherOnJob = this.formData.whetherOnJob == '是' ? 1 : 0;
                        }
                        this.formData.personnel_type = String(this.formData.personnel_type);

                        let contractAppendixList = this.formData.contractAppendix.split(',')
                        contractAppendixList.forEach(e => {
                            this.contractAppendixList.push({
                                name: e,
                                url: e
                            })
                        })
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 上传身份证头像
            beforeCardPicUpload(_file, _el) {
                let _loadingInstance = Loading.service({
                    fullscreen: true,
                    background: 'rgba(255,255,255,0.7)',
                    spinner: 'el-icon-loading',
                    text: _el == 'photo' ? '人脸验证中…' : '图片上传中'
                });
                let _that = this;
                imageConversion.compressAccurately(_file, 200).then(_res => {
                    let reader = new FileReader();
                    reader.onload = function() {
                        let _base64 = this.result;
                        // base64转文件流对象
                        let _fileObject = APP.fnBase64ToFile(_base64);
                        let formData = new FormData();
                        formData.append('file', _fileObject);
                        formData.append('type', 'image');
                        if (_base64.indexOf('data:image/') != -1) {
                            _base64 = _base64.split(',')[1];
                        }
                        fnUpload(formData, res => {
                            if (_el == 'photo') {
                                request({
                                        notLoading: true,
                                        url: 'file/getFaceInfo',
                                        method: 'POST',
                                        data: {
                                            img: _base64
                                        }
                                    })
                                    .then(res => {
                                        if (res.code == APP.HTTP_STATUS.SUCCESS) {
                                            _loadingInstance.close();
                                            _that.faceVerifRes = '人脸照验证成功';
                                            _that.formData[_el] = res.data;
                                        } else {
                                            _loadingInstance.close();
                                            _that.faceVerifRes = res.data;
                                        }
                                    })
                                    .catch(err => {
                                        _loadingInstance.close();
                                        _that.faceVerifRes = err.data;
                                    });
                            } else if (_el == 'contractAppendix') {
                                _that.contractAppendixList.push({
                                    "name": _file.name,
                                    "url": res.data.file_url
                                })
                                _loadingInstance.close();
                            } else {
                                _that.formData[_el] = res.data.file_url;
                                _loadingInstance.close();
                            }
                        });
                    };
                    reader.readAsDataURL(_res);
                });
                return false; // 阻止组件自动上传图片
            },
            // 关闭添加人员弹窗
            fnClosePersonnel() {
                this.isBlackShow = false;
                if (this.path == 'personnelAudit') {
                    this.$parent.fnOpenAddOrEdit();
                } else {
                    this.$parent.fnCloseAddOrEdit();
                }
            },
            // 打开摄像头拍照页面
            fnOpenCameraPage(_el) {
                this.cameraEl = _el; // 拍照类型（身份证头像，身份证正面……）
                this.cameraIsShow = true;
                this.faceVerifRes = '';
                let _video = document.getElementById('cameraVideo');
                let _canvas = document.getElementById('cameraCanvas');
                /* 清空视频和画布 */
                if (_canvas) {
                    let _context = _canvas.getContext('2d');
                    _context.clearRect(0, 0, _canvas.width, _canvas.height);
                }
                if (_video) {
                    _video.src = '';
                }
                setTimeout(() => {
                    this.fnOpenCamera();
                }, 300);
            },
            // 打开摄像头
            fnOpenCamera() {
                let _that = this;
                let _video = document.getElementById('cameraVideo');
                if (navigator.mediaDevices && navigator.mediaDevices.getUserMedia) {
                    navigator.mediaDevices
                        .getUserMedia({
                            video: true,
                            audio: false
                        })
                        .then(function(stream) {
                            _that.mediaStreamTrack = typeof stream.stop === 'function' ? stream : stream
                                .getTracks()[0];
                            _video.srcObject = stream;
                            _video.play();
                        })
                        .catch(function(err) {});
                } else if (navigator.getMedia) {
                    navigator
                        .getMedia({
                            video: true,
                            audio: false
                        })
                        .then(function(stream) {
                            _that.mediaStreamTrack = stream.getTracks()[0];
                            _video.srcObject = stream;
                            _video.play();
                        })
                        .catch(function(err) {
                            console.log(err);
                        });
                } else {
                    this.$message.warning('您的浏览器不支持调用摄像头拍照，请切换其他浏览器');
                }
            },
            // 关闭摄像头
            fnCloseCamera() {
                this.mediaStreamTrack && this.mediaStreamTrack.stop();
            },
            // 拍照
            fnSnap() {
                let _that = this;
                let _canvas = document.getElementById('cameraCanvas');
                let _context = _canvas.getContext('2d');
                let _video = document.getElementById('cameraVideo');
                _context.drawImage(_video, 0, 0, 400, 300);
                // 只有可见光照需要验证是否有人脸
                if (_that.cameraEl == 'photo') {
                    let _loadingInstance = Loading.service({
                        fullscreen: true,
                        background: 'rgba(255,255,255,0.7)',
                        spinner: 'el-icon-loading',
                        text: '人脸验证中…'
                    });
                    let _base64 = _canvas.toDataURL(_canvas, 0.3); // 压缩图片质量
                    let _fileObject = APP.fnBase64ToFile(_base64);
                    imageConversion.compressAccurately(_fileObject, 200).then(_res => {
                        let reader = new FileReader();
                        reader.onload = function() {
                            let _base64 = this.result;
                            if (_base64.indexOf('data:image/') != -1) {
                                _base64 = _base64.split(',')[1];
                            }
                            request({
                                    notLoading: true,
                                    url: 'file/getFaceInfo',
                                    method: 'POST',
                                    data: {
                                        img: _base64
                                    }
                                })
                                .then(res => {
                                    _loadingInstance.close();
                                    _that.faceVerifRes = '人脸照验证成功';
                                    _that.formData[_that.cameraEl] = res.data;
                                    _that.fnSavePhoto();
                                })
                                .catch(err => {
                                    _loadingInstance.close();
                                    _that.faceVerifRes = err.data;
                                });
                        };
                        reader.readAsDataURL(_res);
                    });
                } else {
                    this.fnSavePhoto();
                }
            },
            // 保存拍照图片并转为base64
            fnSavePhoto() {
                let _canvas = document.getElementById('cameraCanvas');
                let _base64 = _canvas.toDataURL(_canvas, 0.3); // 压缩图片质量
                if (this.cameraEl != 'photo') {
                    // base64转文件流对象
                    let _fileObject = APP.fnBase64ToFile(_base64);
                    let formData = new FormData();
                    formData.append('file', _fileObject);
                    formData.append('type', 'image');
                    fnUpload(formData, res => {
                        this.formData[this.cameraEl] = res.data.file_url;
                    });
                }
                this.fnCloseCamera(); // 关闭摄像头
                this.cameraIsShow = false; // 关闭拍照弹窗
            },
            // 关闭拍照弹窗
            fnCloseCameraWin() {
                this.fnCloseCamera(); // 关闭摄像头
                this.cameraIsShow = false; // 关闭拍照弹窗
            },
            // 连接身份证阅读器
            fnConnectCert(_cb) {
                if (typeof CertCtl.connect === 'undefined') {
                    this.$alert(
                        "<p>您的设备暂不支持身份证读取，请确认是否安装阅读器插件（点击此处下载:<a style='color: blue;text-underline: blue' href='https://cqzgzl.oss-cn-chengdu.aliyuncs.com/Trivia/%E4%BA%8C%E4%BB%A3%E5%B1%85%E6%B0%91%E8%BA%AB%E4%BB%BD%E8%AF%81%E8%AF%BB%E5%86%99%E5%99%A8%E6%8E%A5%E5%8F%A3%202.5.0.exe'>下载身份证阅读器</a>），或更换至<a style='color: blue;text-underline: blue' href='https://browser.360.cn/ee/'>360极速浏览器</a>,并切换至极速模式进行身份证读取</p>",
                        '提示', {
                            center: true,
                            dangerouslyUseHTMLString: true
                        }
                    );
                    return;
                }
                let _strResult = CertCtl.connect();
                let jsValue = eval('(' + _strResult + ')');
                if (jsValue.resultFlag == 0) {
                    _cb && _cb();
                } else {
                    this.$alert(
                        "<p>身份证阅读器连接失败，请确认是否安装阅读器插件（点击此处下载:<a style='color: blue;text-underline: blue' href='https://cqzgzl.oss-cn-chengdu.aliyuncs.com/Trivia/%E4%BA%8C%E4%BB%A3%E5%B1%85%E6%B0%91%E8%BA%AB%E4%BB%BD%E8%AF%81%E8%AF%BB%E5%86%99%E5%99%A8%E6%8E%A5%E5%8F%A3%202.5.0.exe'>下载身份证阅读器</a>），请更换至360极速浏览器,并切换至极速模式进行身份证读取</p>",
                        '提示', {
                            center: true,
                            dangerouslyUseHTMLString: true
                        }
                    );
                }
            },
            searchPersonnelDatabaseNameFilter(_v) {
                this.formData.name = _v
            },
            fnChangePersonnel(_data) {
                APP.fnChangePersonnel(this, _data, 'formData')
            },
            fnSearchPersonnelDatabaseName() {
                APP.fnSearchPersonnelDatabaseName(this.formData.name, this)
            },
            fnSearchPersonnelDatabase(_idcard, _read) {
                APP.fnSearchPersonnelDatabase(_idcard, _read, this, 'formData')
            },
            // 读取身份证信息
            fnReadCard() {
                this.fnConnectCert(res => {
                    let _strResult = CertCtl.readCert();
                    let _jsValue = eval('(' + _strResult + ')');
                    if (_jsValue.resultFlag == 0) {
                        this.$message.success('身份证信息读取成功');
                        let _birthday = APP.fnDateAddEm_public(_jsValue.resultContent.bornDay);
                        let _validityPeriod = [APP.fnDateAddEm_public(_jsValue.resultContent.effDate), APP
                            .fnDateAddEm_public(_jsValue.resultContent.expDate)
                        ];
                        this.formData.name = _jsValue.resultContent.partyName;
                        this.formData.sex = _jsValue.resultContent.gender == 0 ? 2 : 1;
                        this.formData.address = _jsValue.resultContent.certAddress;
                        this.formData.idcard = _jsValue.resultContent.certNumber;
                        this.fnSearchPersonnelDatabase(this.formData.idcard, 1);
                        this.formData.cert_org = _jsValue.resultContent.certOrg;
                        if (_validityPeriod[1] == '长期') {
                            this.dateStart = _validityPeriod[0];
                            this.dateEnd = _validityPeriod[1];
                            this.showDate = false;
                        } else {
                            this.showDate = true;
                            this.formData.validity_period = _validityPeriod;
                        }
                        this.formData.birthday = _birthday;
                        this.formData.nation = _jsValue.resultContent.nation;

                        if (!this.formData.nativePlac) {
                            this.formData.nativePlac = this.formData.address;
                        }
                        // base64转文件流对象
                        let _fileObject = APP.fnBase64ToFile('data:image/png;base64,' + _jsValue.resultContent
                            .identityPic);
                        let formData = new FormData();
                        formData.append('file', _fileObject);
                        formData.append('type', 'image');
                        fnUpload(formData, res => {
                            this.formData.id_card_pic = res.data.file_url;
                        });
                    } else {
                        this.$message('身份证读取失败');
                    }
                });
            },
            // 扩展信息
            addOrEditPersonnelExtend() {
                this.personnelExtend.region = 'gzs';
                if (this.personnelExtend.personnel_type == 1) {
                    // 企业人员
                    this.personnelExtend.whetherOnJob = this.personnelExtend.whetherOnJob == 1 ? '在职' : '离职';
                } else {
                    // 项目人员
                    this.personnelExtend.whetherOnJob = this.personnelExtend.whetherOnJob == 1 ? '是' : '否';
                }
                request({
                        url: 'personnel/addOrEditPersonnelExtend',
                        method: 'POST',
                        data: this.personnelExtend
                    })
                    .then(res => {
                        if (this.path == 'personnelAudit') {
                            this.$parent.getInout(this.AuditData);
                            this.$parent.fnOpenAddOrEdit();
                        } else {
                            this.$message.success(this.message);
                            this.$parent.fnCloseAddOrEdit();
                            fnCookie('lastPersonnelInfo', {});
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },
            // 公共信息
            addEditPersonnel() {
                request({
                        url: 'personnel/addEditPersonnel',
                        method: 'POST',
                        data: {
                            personnel_info: JSON.stringify(this.addEditpersonnelInfo)
                        }
                    })
                    .then(res => {
                        this.message = res.data;
                        this.personnel_Id = res.data.personnel_id;
                        this.addOrEditPersonnelExtend();
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },

            // 判断人员是否在黑名单
            fnGetPerisBlack() {
                if (!this.formData.idcard) {
                    return this.$message.warning('请输入身份证号！');
                }
                request({
                        url: 'blacklist/judge',
                        method: 'GET',
                        params: {
                            idcard: this.formData.idcard
                        }
                    })
                    .then(res => {
                        if (res.data) {
                            this.blackMsg = res.data;
                            this.isBlackShow = true;
                        } else {
                            this.fnAddPersonnel();
                        }
                    })
                    .catch(err => {
                        this.$message.error(err.data);
                    });
            },

            // 编辑添加人员
            fnAddPersonnel() {
                this.isBlackShow = false;

                // 处理合同附件
                let contractAppendixList = this.contractAppendixList.map(e => {
                    return e.url
                })
                this.formData.contractAppendix = contractAppendixList.join(',')

                // 需要验证的字段
                let _needField = {
                    name: '姓名',
                    sex: '性别',
                    address: '住址',
                    nation: '民族',
                    department: '班组',
                    position: '工人工种类型',
                    phone: '手机号码',
                    idcard: '身份证号',
                    validity_period: '证件有效期',
                    id_card_pic: '身份证头像',
                    postType: '贵州人社岗位类型',
                    positionTypeStr: '贵州省岗位类型',
                    // payRollBankCardNum: '工人工资卡银行卡号',
                    payRollBankCardType: '工资卡类别',
                    // payRollBankName: '工人工资卡所属银行支行名称',
                    // payrollBank: '工人工资卡所属银行',
                    hasContract: '是否有劳动合同',
                    hasWorkInsurance: '是否购买工伤保险',
                    whetherOnDuty: '是否在岗',
                    hasAccidentInsurance: '是否购买意外伤害保险',
                    miurInsurance: '是否参加城乡居民医疗保险',
                    endowmentInsurance: '是否参加城乡居民养老保险',
                    wageApprovedWay: '工种工资核定方式',
                    wageCriterion: '工种工资核定标准',
                    payDate: '工资支付日期',
                    whetherOnJob: '是否在职',
                    personnel_type: ' 人员类型',
                    // contractCode: '合同编号',
                    role: '人员角色',
                    // laborContractType: '合同期限类型',
                    // contractValidDate: '合同签订日期',
                    // contractInvalidDate: '合同终止日期',
                    // contractType: '签订书面合同类型',
                    // contractAppendix: '合同附件',
                    education: '文化程度',
                    politicalFace: '政治面貌',
                    cert_org: '发证机关'
                };
                for (let _key in _needField) {
                    if (this.formData[_key] === null || this.formData[_key] === '' || this.formData[_key] ===
                        undefined) {
                        if (_key == 'validity_period') {
                            if (this.showDate == false && this.dateStart == '') {
                                this.$message.warning('人员' + _needField[_key] + '不能为空');
                                return;
                            }
                        } else {
                            this.$message.warning('人员' + _needField[_key] + '不能为空');
                            return;
                        }
                    }
                }
                const reg = /^1[3|4|5|6|7|8|9][0-9]\d{8}$/;
                if (!reg.test(this.formData.phone)) {
                    this.$message.warning('请输入正确的手机号');
                    return;
                }
                if (this.formData.idcard.length !== 18) {
                    this.$message.warning('请输入正确的身份证号');
                    return;
                }
                if (this.formData.payRollBankCardNum && (this.formData.payRollBankCardNum.length < 12 || this.formData
                        .payRollBankCardNum.length > 22)) {
                    // 银行卡长度验证
                    this.$message.warning('工人工资卡银行卡号应为12-22位正整数字符(无符号)');
                    return;
                }
                if (this.formData.payRollBankName && (this.formData.payRollBankName.length < 6 || this.formData
                        .payRollBankName.length > 100)) {
                    this.$message.warning('工人工资卡所属银行支行名称应为6-100位中文字符，可含中文括号');
                    return;
                }
                if (this.formData.contractCode && (this.formData.contractCode.length < 2 || this.formData.contractCode
                        .length > 80)) {
                    this.$message.warning('工人合同编号应为2-80位中英文可见字符');
                    return;
                }
                if (this.formData.address == this.formData.nativePlac) {
                    this.$message.warning('籍贯和住址不能相同，请重新填写');
                    return;
                }

                // 去掉卡号前面的0
                let regex = /^[0]+/;
                if (this.formData.card_no) {
                    this.formData.card_no = this.formData.card_no.replace(regex, '');
                }

                if (this.showDate) {
                    let _validity_period = this.formData.validity_period;
                    if (_validity_period) {
                        this.formData.validity_period = APP.fnDateReduceEm_public(_validity_period[0]) + '-' + APP
                            .fnDateReduceEm_public(_validity_period[1]);
                    }
                } else {
                    this.formData.validity_period = APP.fnDateReduceEm_public(this.dateStart) + '-' + this.dateEnd;
                }
                this.formData.idcard = this.formData.idcard.toLowerCase(); // 身份证号转小写
                this.formData.idcard_sha1 = sha1(this.formData.idcard); // 身份证sha1加密
                this.isSaveDisabled = true; // 禁用保存按钮
                setTimeout(() => {
                    this.isSaveDisabled = false;
                }, 1500);
                if (this.editInfo && this.editInfo.id) {
                    for (let _key in this.formData) {
                        if (this.editInfo.hasOwnProperty(_key)) {
                            this.addEditpersonnelInfo[_key] = this.formData[_key];
                        } else {
                            this.personnelExtend.personnel_id = this.editInfo.id;
                            this.personnelExtend.id = this.editInfo.project_id;
                            this.personnelExtend[_key] = this.formData[_key];
                        }
                    }
                    this.addEditPersonnel();
                } else {
                    for (let _key in this.formData) {
                        if (this.jibenData.hasOwnProperty(_key)) {
                            this.addEditpersonnelInfo[_key] = this.formData[_key];
                        }
                        if (this.kuozandata.hasOwnProperty(_key)) {
                            this.personnelExtend[_key] = this.formData[_key];
                        }
                    }
                    request({
                            url: 'personnel/addEditPersonnel',
                            method: 'POST',
                            data: {
                                personnel_info: JSON.stringify(this.addEditpersonnelInfo)
                            }
                        })
                        .then(res => {
                            this.message = res.data;
                            this.personnelExtend.personnel_id = res.data.personnel_id;
                            this.addOrEditPersonnelExtend();
                        })
                        .catch(err => {
                            this.$message.error(err.data);
                        });
                }
            },
            // 人员审核页面操作
            // 审核不通过
            fnAuditNot() {
                this.$parent.getNoInout(this.AuditData);
                this.$parent.fnOpenAddOrEdit();
            },
            // 删除合同图片
            handleRemove(file, fileList) {
                let arr = []
                this.contractAppendixList.forEach(e => {
                    if (e.uid != file.uid) arr.push(e);
                })
                this.contractAppendixList = arr
            },
            // 查看合同图片
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            }
        }
    };
</script>

<style scoped lang="scss" type="text/scss">
    @import '~@/styles/mixin.scss';
.btn_line {
  @include flex-box(center, center);
  width: 100%;
}
.dialog_addperson {
  >>> .el-dialog {
    @include flex-box($direction: column);
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
  >>> .el-dialog__body {
    @include flex-box();
    display: -webkit-box;
    padding-bottom: 80px;
  }
  >>> .avatar-uploader {
    line-height: 100px;
    margin-right: 10px;
    img {
      width: 98px;
      height: 98px;
      border-radius: 2px;
    }
  }
  >>> .avatar-uploader-s {
    li {
      width: 100px;
      height: 100px;
    }
  }
  >>> .el-upload {
    width: 100px;
    height: 100px;
    line-height: 100px;
  }
  // 按钮样式
  >>> .el-button {
    width: 110px;
    height: 40px;
    background: url(../../../../assets/img/btn_bg_bsm.png) no-repeat;
    background-size: 100% 100%;
    border: none;
  }
  // 上传图片样式
  >>> .el-upload--picture-card {
    background-color: rgba(9, 17, 32, 0.5);
  }
  >>> .el-input__inner {
    width: 280px;
    height: 30px;
    border-radius: 2px;
    border: none;
    color: rgba(77, 180, 244, 0.7);
    background-color: rgba(77, 180, 244, 0.2);
    &::-webkit-input-placeholder {
      color: rgba(77, 180, 244, 0.7);
    }
    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: rgba(77, 180, 244, 0.7);
    }
  }
  >>> .el-select {
    .el-input {
      .el-select__caret {
        color: rgba(77, 180, 244, 0.7);
      }
    }
  }
  >>> .el-select-dropdown {
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(77, 180, 244, 1);
  }
  >>> .popper__arrow {
    border-bottom-color: rgba(77, 180, 244, 1) !important;
  }
  >>> .el-select-dropdown__item {
    color: rgba(77, 180, 244, 0.7);
  }
  >>> .el-select-dropdown__item:hover {
    color: #409eff;
  }
  >>> .el-select-dropdown__item.hover {
    color: #409eff;
  }
  >>> .el-input__icon {
    color: rgba(77, 180, 244, 0.7);
  }
  >>> .el-range-input {
    color: rgba(77, 180, 244, 0.7);
    background: transparent;
    &::-webkit-input-placeholder {
      color: rgba(77, 180, 244, 0.7);
    }
    &::-moz-placeholder {
      /* Mozilla Firefox 19+ */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-moz-placeholder {
      /* Mozilla Firefox 4 to 18 */
      color: rgba(77, 180, 244, 0.7);
    }
    &:-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: rgba(77, 180, 244, 0.7);
    }
  }
  >>> .el-range-separator {
    color: rgba(77, 180, 244, 0.7);
  }
  >>> .el-radio {
    color: rgba(255, 255, 255, 0.8);
  }

  .item {
    border: 1px solid #4db4f4;
    &:last-of-type {
      .row {
        &:last-of-type {
          border-bottom: 1px solid #4db4f4;
        }
      }
    }
    .row {
      // color: #4DB4F4;
      color: rgba(255, 255, 255, 0.8);
      line-height: 36px;
      border-bottom: 1px solid #4db4f4;
      @include flex-box();
      &:last-of-type {
        border-bottom: 0;
      }
      .row-item {
        padding: 5px 0 5px 15px;
        @include flex-item();
        @include flex-box($align: center);
        &:first-of-type {
          border-right: 1px solid #4db4f4;
        }
        .el-input {
          max-width: 300px;
        }
      }
    }
    &.left-item {
      width: 49%;
      margin-right: 2%;
      .row:last-of-type {
        border-bottom: 1px solid #4db4f4;
      }
    }
    &.right-item {
      @include flex-item();
      .row:last-of-type {
        border-bottom: 1px solid #4db4f4;
      }
    }
  }
}
.dialog_camera {
  >>> .el-dialog {
    width: 858px;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
}
.dialog_isBlack {
  .btn_line {
    @include flex-box(center, center);
  }
  >>> .el-dialog {
    width: 500px;
    height: 200px;
    margin-top: 40vh !important;
    background-color: rgba(9, 17, 32, 1);
    border: 1px solid rgba(58, 116, 221, 1);
  }
  >>> .el-form-item__label {
    color: #4db4f4;
  }
  >>> .el-dialog__title {
    color: #4db4f4;
  }
  >>> .el-dialog__close {
    color: #4db4f4;
  }
  div {
    width: 100%;
    text-align: center;
    color: rgba(255, 255, 255, 0.8);
  }
}
.printhide {
  background-color: #091120;
  height: 80px;
  width: 100%;
  display: flex;
  bottom: 0;
  position: fixed;
  _position: absolute;
  z-index: 9999;
  _top: expression(
    eval(document.compatMode && document.compatMode==‘CSS1Compat’) ? documentElement.scrollTop + (documentElement.clientHeight-this.clientHeight) - 0: document.body.scrollTop +
      (document.body.clientHeight-this.clientHeight) - 0
  );
  width: 100%;
  z-index: 9999;
}
</style>



// WEBPACK FOOTER //
// src/views/Person/personGzzj/components/AddPerson.vue